import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuccessModalComponent } from './success-modal.component';

@NgModule({
  declarations: [SuccessModalComponent],
  imports: [CommonModule],
  exports: [SuccessModalComponent],
  entryComponents: [SuccessModalComponent],
})
export class SuccessModalModule {}
